import { render, staticRenderFns } from "./RefreshAlgolia.vue?vue&type=template&id=116dbefc"
import script from "./RefreshAlgolia.vue?vue&type=script&lang=js"
export * from "./RefreshAlgolia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports